import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ondemand-features',
  templateUrl: './ondemand-features.component.html',
  styleUrls: ['./ondemand-features.component.scss']
})
export class OndemandFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
